import { clearAppAttribution } from "./attributionController.js";
import { acquisitionAttribution } from "./acquisitionAttribution.js";
import { attributionConsent } from "./consent.js";

// Run at the HTTP boundary too: callers cannot bypass consent or the allowlist.
export function signupPayload(payload, consent = attributionConsent, service = acquisitionAttribution) {
  const { attribution, ...credentials } = payload;
  try {
    const safe = consent.hasConsent()
      ? (service.forSubmission ? service.forSubmission(attribution) : service.validate(attribution)) : null;
    return safe ? { ...credentials, attribution: safe } : credentials;
  } catch { return credentials; }
}

export function completeSignup(response, google = false, service = acquisitionAttribution) {
  if (typeof response?.authToken === "string" && response.authToken.trim() &&
      (!google || response.action === "signup")) {
    try {
      if (service === acquisitionAttribution) clearAppAttribution();
      else service.clear();
    } catch { /* Keep successful auth successful. */ }
  }
  return response;
}
